'use strict';

const { captureMessage } = require('../analytics/sentry');
var userId = window.wooGlobal.user && window.wooGlobal.user.id;

function overviewResetExpertStatus () {
  $.ajax({
    type: 'POST',
    cache: false,
    url: './resetexpertstatus',
    success: function (data) {
      var $expertsBox = $('#expert-notification');
      $expertsBox.addClass('hidden');
    },
    error: function (jqXHR, textStatus, errorThrown) {
      captureMessage('Overview reset expert status', {
        extra: {
          textStatus: textStatus,
          errorThrown: errorThrown,
          userId: userId
        }
      });
    }
  });
}

$.ajax({
  type: 'POST',
  cache: false,
  url: './getexpertstatus',
  dataType: 'json',
  success: function (data) {
    if (data.expertStatus === 'INTERESTED') {
      var $expertsBox = $('#expert-notification');
      $expertsBox.removeClass('hidden');

      $expertsBox.on('click', '.close', function (event) {
        overviewResetExpertStatus();
      });
    }
  },
  error: function (jqXHR, textStatus, errorThrown) {
    captureMessage('Overview get expert status', {
      extra: {
        textStatus: textStatus,
        errorThrown: errorThrown
      }
    });
  }
});
